// extracted by mini-css-extract-plugin
module.exports = {"pwBG":"Password_pwBG__3c8XJ","pwstyle":"Password_pwstyle__HaHfE"};